import React from 'react';
import { services } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-lavender-50/50 via-white to-white relative overflow-hidden">
      {/* 3D Floral background decorations */}
      <div className="absolute top-20 left-10 w-72 h-72">
        <div className="absolute w-48 h-48 bg-lavender-100/50 rounded-full blur-3xl" />
        <div className="absolute top-10 left-10 w-6 h-12 bg-lavender-300/30 rounded-full blur-[2px] rotate-[30deg] floral-accent" />
      </div>
      <div className="absolute bottom-20 right-10 w-96 h-96">
        <div className="absolute w-64 h-64 bg-lilac-100/40 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-8 h-16 bg-violet-200/30 rounded-full blur-[2px] -rotate-[45deg] floral-accent" />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-lavender-600 text-sm tracking-[0.2em] uppercase mb-4" style={{ fontFamily: "'Lato', sans-serif" }}>
            What We Offer
          </span>
          <h2
            className="text-4xl sm:text-5xl text-grape-800 mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Event Design & Planning Services
          </h2>
          <p className="text-grape-600/70 text-lg max-w-2xl mx-auto" style={{ fontFamily: "'Lato', sans-serif" }}>
            From wedding coordination to birthday celebrations, we bring your vision to life with elegance and intention as your Florida event planner.
          </p>
        </div>
        
        {/* Services Grid with 3D cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article
              key={service.id}
              className="group relative card-3d"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Card floral glow */}
              <div className="absolute -inset-2 bg-gradient-to-br from-lavender-200/30 via-lilac-100/20 to-transparent rounded-3xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative bg-white rounded-2xl shadow-xl shadow-lavender-900/10 overflow-hidden">
                {/* Service Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={service.imageUrl}
                    alt={`Hem of Grace Events ${service.title} Florida event planning`}
                    className="w-full h-full object-cover image-hover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-grape-900/40 via-grape-900/10 to-transparent" />
                  
                  {/* Title overlay on image */}
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3
                      className="text-2xl text-white drop-shadow-lg"
                      style={{ fontFamily: "'Cormorant Garamond', serif" }}
                    >
                      {service.title}
                    </h3>
                  </div>
                </div>
                
                {/* Service Content */}
                <div className="p-6">
                  <p className="text-grape-600/80 mb-4" style={{ fontFamily: "'Lato', sans-serif" }}>
                    {service.description}
                  </p>
                  
                  {/* Features List */}
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start text-sm text-grape-600/70" style={{ fontFamily: "'Lato', sans-serif" }}>
                        <span className="w-1.5 h-1.5 bg-lavender-400 rounded-full mt-2 mr-3 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  
                  {/* CTA Button */}
                  <button
                    onClick={scrollToContact}
                    className="inline-flex items-center text-lavender-600 font-medium hover:text-violet-700 transition-colors group/btn"
                    style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem' }}
                  >
                    Plan Your Event
                    <ArrowRight className="w-4 h-4 ml-2 transform group-hover/btn:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
